var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"rkm-main",style:(_vm.style)},[_c('div',{staticClass:"rkm-main-wrap"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }